import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { ControllerBase } from "controllerBase";
import global from 'globalMU'
import { PlanoPagamentoController } from './planoPagamentoController'



declare var window:any
declare var ParcelaView:any
declare var Parcelas:any
declare var EditarParcelaController:any



const { forEach } = require("p-iteration");


const FormaPagamentoController = ControllerBase.extend({
    name: "FormaPagamentoController",
    form: "#form-pesquisar-formas-pagamento",

    renderizar: function (renderizacaoCompletaCallback) {
        var self = this;
        var identificadorOrcamento = this.model.get("IdentificadorOrcamento");
        var codigoFormaPagamento = this.model.get("CodigoFormaPagamento");
        var codigoTipoDocumento = this.model.get("CodigoTipoDocumento");
        var valorOrcamento = this.model.get("ValorTotal");
        var verificarPendenciaFormaDePagamento = this.model.get("VerificarPendenciaFormaDePagamento");
        var tipoOrcamento = this.model.get("TipoOrcamento");

        global.ajax({
            url: "/Orcamento/_FormaPagamento",
            type: "get",
            cache: false,
            data: {
                identificadorOrcamento: identificadorOrcamento,
                codigoFormaPagamento: codigoFormaPagamento,
                codigoTipoDocumento: codigoTipoDocumento,
                valorOrcamento: valorOrcamento,
                verificarPendenciaFormaDePagamento: verificarPendenciaFormaDePagamento,
                tipoOrcamento: tipoOrcamento
            },
            success: function (data) {
                $(self.container).show();
                $(self.container).empty();
                $(self.container).html(data);

                if (renderizacaoCompletaCallback && $.isFunction(renderizacaoCompletaCallback)) {
                    renderizacaoCompletaCallback();
                }
            }
        });
    },

    initialize: function () {
        
        this.model.on("change:AtualizarParcelas", this.atualizarParcelas, this);
    },

    dispose: function () {
        if (this.model && this.model.off) // FNX-5001
            this.model.off("change:AtualizarParcelas", this.atualizarParcelas, this); 
    },

    antesRenderizacaoCompleta: function () {

        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(function () {


                if (typeof this
                    .currentRegion ==
                    "undefined" ||
                    typeof this.currentRegion.options == "undefined") {
                    return;
                }

                this.limpar();

                if (PlanoPagamentoController) {
                    PlanoPagamentoController.limpar();
                }


            },
                this)
        },
            true);

    },

    renderizado: function () {
        this.atacharEventos();

        if (this.model.get("UtilizaPlanoPagamento")) {
            $("a[aria-controls=tab-plano-pagamento]").tab("show");
        }

        $("input[name=recalcularParcelas]").prop("checked", this.model.get("RecalcularParcelas"));

        this.mostrarOcultarRodape(!this.model.get("RecalcularParcelas"));
        
        $("#formaPagamento").focus();
    },

    atacharEventos: function () {

        //this.addEvent('planoPagamentoAlterado', this.model, 'change:CodigoPlanoPagamento', this.planoPagamentoAlterado);
        this.model.on("change:CodigoPlanoPagamento", this.planoPagamentoAlterado, this);

        //$(document).on('shown.bs.tab', 'a[data-toggle="tab"]', $.proxy(this.tabSelecionada, this));
        $("a[data-toggle=\"tab\"]", this.region.$el).on("shown.bs.tab", $.proxy(this.tabSelecionada, this));
        $("select[name=formaPagamento]").change($.proxy(this.formaPagamentoAlterada, this));
        $("select[name=tiposDocumento]").change($.proxy(this.tipoDocumentoAlterado, this));
        $("input[name=recalcularParcelas]").change($.proxy(this.recalcularParcelasAlterado, this));
        $("input[name=recalcularVencimentoNoFaturamento]").change($.proxy(this.recalcularVencimentoNoFaturamentoAlterado, this));
        $("input").on('focus', function () { $(this).select(); });


        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(function () {
                this.model.unset("CodigoFormaPagamento");
                this.model.unset("CodigoTipoDocumento");
                store.dispatch(sobrescreverInformacoesAction({CodigoFormaPagamento: undefined, CodigoTipoDocumento: undefined}))
                
                $("select[name=formaPagamento] option[value=\"\"]").prop("selected", true);
                $("#lista-tipo-documento").empty();
                this.resetRegion("parcelasViewRegion");

                var identificadorOrcamento = this.model.get("IdentificadorOrcamento");

                this.atualizarFormaPagamento(identificadorOrcamento, 0, 0);

                global.ajax({
                    blockUI: false,
                    url: "/Orcamento/ObterTotaisOrcamento",
                    type: "post",
                    contentType: "application/json",
                    data: global.toJSONString({
                        identificadorOrcamento: this.model.get("IdentificadorOrcamento")
                    }),
                    success: function (data) {
                        data = global.tratarRetorno(data);

                        if (data) {
                            if (this.model != null) {
                                this.model.set("ValorTotalMercadorias", data.ValorTotalMercadorias);
                                this.model.set("ValorDespesasInclusas", data.ValorDespesasInclusas);
                                this.model.set("ValorTotal", data.ValorTotal);
                            }
                        }
                        
                    }
                });

            },
                this)
        },
            true);

    },

    selecionarTipoDocumento: function (codigoTipoDocumento) {
        $("select[name=tiposDocumento] option[value=" + codigoTipoDocumento + "]").prop("selected", true);
    },

    formaPagamentoAlterada: function (e) {

        var $tiposDocumento = $("#lista-tipo-documento");
        $tiposDocumento.empty();
        this.resetRegion("parcelasViewRegion");

        var codigoFormaPagamento = $(e.target).val();

        if (!codigoFormaPagamento) {
            this.model.unset("CodigoFormaPagamento");
            store.dispatch(sobrescreverInformacoesAction({CodigoFormaPagamento: undefined}))
            return;
        }

        var identificadorOrcamento = this.model.get("IdentificadorOrcamento");
        this.model.set("CodigoFormaPagamento", codigoFormaPagamento);
        store.dispatch(sobrescreverInformacoesAction({CodigoFormaPagamento: codigoFormaPagamento}))

        this.atualizarFormaPagamento(identificadorOrcamento, codigoFormaPagamento, null);

        global.ajax({
            url: "/Orcamento/TiposDocumento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: identificadorOrcamento,
                codigoFormaPagamento: codigoFormaPagamento
            }),
            success: function (data) {

                var option = $("<option>");
                option.html("Selecione");
                $tiposDocumento.append(option);

                if (data && data.length > 0) {
                    $.each(data,
                        function () {
                            option = $("<option>",
                            {
                                value: this.Codigo
                            });
                            option.html(this.Descricao);
                            $tiposDocumento.append(option);
                        });
                }

            }
        });
    },

    atualizarParcelas: function (parcelas) {

        if (!parcelas || !$.isArray(parcelas)) {
            parcelas = this.model.get("ParcelasFormaPagamento");
        }

        var somenteLeitura = false;
        if (this.model !== null && this.model.get) { // FNX-5001
            somenteLeitura = this.model.get("SomenteLeitura");
        }

        this.parcelaView = this.showView({
            region: {
                name: "parcelasViewRegion",
                selector: "#parcelas-region"
            },
            view: {
                type: ParcelaView,
                args: {
                    model: this.model,
                    collection: new Parcelas(parcelas),
                    readOnly: somenteLeitura,
                }
            }
        });

        // this.model.attributes.ParcelasFormaPagamento = parcelas; // MANUT-446
        this.model.set("ParcelasFormaPagamento",parcelas)
        store.dispatch(sobrescreverInformacoesAction({ParcelasFormaPagamento: parcelas}))
        
        this.iniciarBotoesEdicaoParcela();
        
        this.mostrarTotalParcelas(parcelas);
    },

    incluirParcela: function () {

        this.editarParcelaController = this.showView({
            region: {
                name: "editarParcelaRegion",
                selector: "#editar-parcela-region"
            },
            controller: {
                type: EditarParcelaController,
                args: {
                    orcamento: this.model,
                    finalizarEdicaoCallback: $.proxy(this.finalizarEdicaoParcela, this),
                    cancelarEdicaoCallback: $.proxy(this.cancelarEdicaoParcela, this),
                    readOnly: this.model.get("SomenteLeitura")
                }
            }
        });

    },

    finalizarEdicaoParcela: function (data) {
        if (!data || !data.ParcelasFormaPagamento) {
            return;
        }

        this.atualizarParcelas(data.ParcelasFormaPagamento);

        this.editarParcelaController.hide();
        this.show();
    },

    cancelarEdicaoParcela: function () {

    },

    igualarParcelasPrazo: function () {
        var self = this;

        global.ajax({
            url: "/Orcamento/IgualarParcelasPrazo",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.model.get("IdentificadorOrcamento")
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                self.model.set("ParcelasFormaPagamento", data.ParcelasFormaPagamento);
                self.atualizarParcelas(data.ParcelasFormaPagamento);
                self.habilitarBotoesEdicaoParcela();
            }
        });

    },  

    excluirParcela: function () {

        var parcelas = this.parcelaView.collection.toJSON();

        var selecionados = parcelas ? global.where(parcelas, { selecionado: true }) : null;

        if (!selecionados || selecionados.length == 0) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/ExcluirParcelas",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.model.get("IdentificadorOrcamento"),
                parcelas: selecionados
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                self.model.set("ParcelasFormaPagamento", data.ParcelasFormaPagamento);
                self.atualizarParcelas(data.ParcelasFormaPagamento);
                self.habilitarBotoesEdicaoParcela();
            }
        });


    },


    mostrarTotalParcelas: function ( parcelas ) {
        if (parcelas) {
            var vrOrcamento = this.orcamentoController.model.get("ValorTotal");
            // da erro no ugligy --->var totalParcelas = data.ParcelasFormaPagamento.reduce((sum, parcela) => sum + parcela.Valor, 0);
            var existePrazo = false;
            var totalParcelas = 0
            parcelas.forEach(function (parc) {
                totalParcelas += Math.round(parc.Valor * 100) / 100;
                if (parc.Tipo == 2) existePrazo = true;
            });
            var diferenca = Math.round((vrOrcamento - totalParcelas) * 100) / 100;
            //if (diferenca > 0) {
            //    global.showInfoMessage("Total das parcelas: " + global.formatMoney(totalParcelas) + "<br>Diferença: " + global.formatMoney(diferenca));
            //}
            $("#forma-de-pagamento-parcelas-orcamento-rodape-soma").text(global.formatMoney(totalParcelas));
            $("#forma-de-pagamento-parcelas-orcamento-rodape-diferenca").text(global.formatNumber(diferenca));
            if (diferenca !== 0 || !this.model.get("RecalcularParcelas"))
                $("#forma-de-pagamento-parcelas-orcamento-rodape").show();
            else
                $("#forma-de-pagamento-parcelas-orcamento-rodape").hide();

            if (existePrazo)
                $("#forma_pagamento_igualarParcelaPrazo").show();
            else
                $("#forma_pagamento_igualarParcelaPrazo").hide();
        }
    },

    iniciarBotoesEdicaoParcela: function () {

        $("#acoes-parcelas button").unbind();
        $("#acoes-parcelas .icone-incluir").click($.proxy(this.incluirParcela, this));
        $("#acoes-parcelas .icone-excluir").click($.proxy(this.excluirParcela, this));
        $("#forma_pagamento_igualarParcelaPrazo").click($.proxy(this.igualarParcelasPrazo, this));


        if (this.parcelaView) {
            $("#acoes-parcelas").show();
        } else {
            $("#acoes-parcelas").hide();
        }

    },

    habilitarBotoesEdicaoParcela: function () {

        if (!this.parcelaView) {
            return;
        }

        var parcelas = this.parcelaView.collection;

        var selecionados = parcelas ? parcelas.where({ selecionado: true }) : null;

        var habilitarExcluir = selecionados && selecionados.length > 0;

        $("#acoes-parcelas .icone-excluir").prop("disabled", !habilitarExcluir);
    },

    tipoDocumentoAlterado: function (e) {

        var codigoTipoDocumento = $(e.target).val();

        if (!codigoTipoDocumento) {
            this.model.unset("CodigoTipoDocumento");
            store.dispatch(sobrescreverInformacoesAction({CodigoTipoDocumento: undefined}))
            return;
        }

        this.model.set("CodigoTipoDocumento", codigoTipoDocumento);
        store.dispatch(sobrescreverInformacoesAction({CodigoTipoDocumento: codigoTipoDocumento}))

        var self = this;

        var identificadorOrcamento = this.model.get("IdentificadorOrcamento");
        var codigoFormaPagamento = this.model.get("CodigoFormaPagamento");

        this.atualizarFormaPagamento(identificadorOrcamento, codigoFormaPagamento, codigoTipoDocumento);
    },

    recalcularParcelasAlterado: function (e) {
        var recalcular = $(e.target).prop("checked");
        var identificadorOrcamento = this.model.get("IdentificadorOrcamento");

        this.model.set("RecalcularParcelas", recalcular);
        store.dispatch(sobrescreverInformacoesAction({RecalcularParcelas: recalcular}))

        global.ajax({
            url: "/Orcamento/AtualizarRecalcularParcelas",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: identificadorOrcamento,
                recalcular: recalcular
            })
        });

        this.mostrarOcultarRodape(!recalcular);

    },

    mostrarOcultarRodape: function (mostrar) {
        
        //this.mostrarTotalParcelas()
        if (mostrar) {
            $("#forma-de-pagamento-parcelas-orcamento-rodape").show();
        }
        else {
            $("#forma-de-pagamento-parcelas-orcamento-rodape").hide();
        }
    },


    recalcularVencimentoNoFaturamentoAlterado: function (e) {
        var recalcular = $(e.target).prop("checked");
        var identificadorOrcamento = this.model.get("IdentificadorOrcamento");

        this.model.set("RecalcularVencimentoNoFaturamento", recalcular);
        store.dispatch(sobrescreverInformacoesAction({RecalcularVencimentoNoFaturamento: recalcular}))

        global.ajax({
            url: "/Orcamento/AtualizarRecalcularVencimentoNoFaturamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: identificadorOrcamento,
                recalcular: recalcular
            })
        });

    },

    atualizarFormaPagamento: function (identificadorOrcamento, codigoFormaPagamento, codigoTipoDocumento) {
        var self = this;
        var valorOrcamento = self.model.get("ValorTotal");
        var verificarPendenciaFormaDePagamento = self.model.get("VerificarPendenciaFormaDePagamento");

        global.ajax({
            url: "/Orcamento/AtualizarFormaPagamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: identificadorOrcamento,
                codigoFormaPagamento: codigoFormaPagamento,
                codigoTipoDocumento: codigoTipoDocumento,
                valorOrcamento: valorOrcamento,
                verificarPendenciaFormaDePagamento: verificarPendenciaFormaDePagamento
            }),
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }

                self.model.set("UtilizaPlanoPagamento", data.UtilizaPlanoPagamento);
                store.dispatch(sobrescreverInformacoesAction({UtilizaPlanoPagamento: data.UtilizaPlanoPagamento}))
                self.model.atualizar(data);
                
                //self.pendenciaPrazoMedioEntrega(data.PendenciaPrazoMedioEntrega);
                self.pendencia(data);  // FNX-1656 --- FNX-4640 
            }
        });
    },

    pendencia: function (data) { // FNX-1656 --- FNX-4640 
        var self = this;
        self.pendenciaPrazoMedioEntrega(data.PendenciaPrazoMedioEntrega)
        self.pendenciaTipoDocumentoBloqueadoParaCliente(data.TipoDocumentoBloqueadoParaCliente);
    },

    pendenciaPrazoMedioEntrega: function (pendente) {
        var self = this;
        var verificarPendenciaFormaDePagamento = self.model.get("VerificarPendenciaFormaDePagamento");
        if (verificarPendenciaFormaDePagamento) {
            if (pendente) {
                $("#lbFormaPagamento").css("color", "#f25713 !important"); // FNX-1656
                $("#formaPagamento").css("color", "#000 !important");
                $("#formaPagamento").addClass("erro");
            } else {
                $("#lbFormaPagamento").css("color", "#000 !important"); // FNX-1656
                $("#formaPagamento").removeClass("erro");
            }
        }
    },

    pendenciaTipoDocumentoBloqueadoParaCliente: function (tipoDocumentoBloqueadoParaCliente) { // FNX-1656 --- FNX-4640 
        if (tipoDocumentoBloqueadoParaCliente) { // FNX-4640 
            $("#lbTipoDeDocumento").css("color", "#f25713 !important"); // FNX-1656
            $("#lista-tipo-documento").css("color", "#000 !important");
            $("#lista-tipo-documento").addClass("erro");
        } else {
            $("#lbTipoDeDocumento").css("color", "#000 !important"); // FNX-1656
            $("#lista-tipo-documento").removeClass("erro");
        }
    },

    tabSelecionada: function (e) {

        var name = $(e.target).attr("aria-controls");

        switch (name) {
            case "tab-forma-pagamento":
                this.antesRenderizacaoCompleta();
                break;
            case "tab-plano-pagamento":

                if (this.PlanoPagamentoController) {
                    this.PlanoPagamentoController.antesRenderizacaoCompleta();
                    return;
                }

                this.PlanoPagamentoController = this.showView({
                    region: {
                        name: "planoPagamentoRegion",
                        selector: "#tab-plano-pagamento"
                    },
                    controller: {
                        type: PlanoPagamentoController,
                        args: {
                            orcamento: this.model,
                            readOnly: this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") != "" // FNX-968
                        }
                    }
                });

                this.antesRenderizacaoCompleta();

                break;

        }

    },

    planoPagamentoAlterado: function () {

        if (!this.model.get("CodigoPlanoPagamento")) {
            return;
        }

        this.limpar();

    },

    limpar: function () {
        this.model.unset("CodigoFormaPagamento");
        store.dispatch(sobrescreverInformacoesAction({CodigoFormaPagamento: undefined}))
        $("select[name=formaPagamento]").val("");
        $("select[name=tiposDocumento]").val("");
        $("#parcelas-region").empty();
    }

})

window.FormaPagamentoController = FormaPagamentoController

export {
    FormaPagamentoController
}